import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaArrowLeft } from 'react-icons/fa6';
import * as adminRolesService from '../../data/services/adminRolesService';
import RoleCard from '../components/RoleCard';
import './AdminRolesScreen.css';

const AdminRolesScreen = () => {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadRoles();
  }, []);

  const loadRoles = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await adminRolesService.getAllRoles();
      setRoles(data);
    } catch (err) {
      console.error('Error loading roles:', err);
      setError(err.message || 'Failed to load roles');
    } finally {
      setLoading(false);
    }
  };

  const handleRoleClick = (roleId) => {
    navigate(`/admin/roles/${roleId}`);
  };

  const handleAddRole = () => {
    navigate('/admin/roles/new');
  };

  const handleDelete = async (roleId) => {
    try {
      await adminRolesService.deleteRole(roleId);
      await loadRoles(); // Reload list
    } catch (err) {
      console.error('Error deleting role:', err);
      alert(err.message || 'Failed to delete role');
    }
  };

  const handleBack = () => {
    navigate('/home');
  };

  if (loading) {
    return (
      <div className="admin-roles-screen">
        <div className="loading">Loading roles...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-roles-screen">
        <div className="error-message">Error: {error}</div>
        <button onClick={loadRoles} className="retry-button">Retry</button>
      </div>
    );
  }

  return (
    <div className="admin-roles-screen">
      <header className="admin-roles-header">
        <button
          className="back-button"
          onClick={handleBack}
          aria-label="Back to Main UI"
        >
          <FaArrowLeft className="back-icon" />
        </button>
        <div className="admin-roles-header-content">
          <h1 className="admin-roles-title">
            Roles & Responsibilities
          </h1>
          <p className="admin-roles-subtitle">
            Manage roles, responsibilities, and their associated prompts
          </p>
        </div>
      </header>

      <div className="admin-roles-actions">
        <button
          className="add-role-button"
          onClick={handleAddRole}
        >
          <FaPlus className="add-icon" />
          <span>Add Role</span>
        </button>
      </div>

      <div className="admin-roles-grid">
        {roles.length > 0 ? (
          roles.map((role) => (
            <RoleCard
              key={role.roleId}
              role={role}
              onClick={() => handleRoleClick(role.roleId)}
              onDelete={() => handleDelete(role.roleId)}
            />
          ))
        ) : (
          <div className="empty-message">
            No roles yet. Click "Add Role" to create your first role.
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminRolesScreen;
